import React, { memo } from 'react';
import logo from '../../img/compdata-logo.png';

function CompDataLogo(props) {
  return <img {...props} src={logo} alt="Welcome to CompData" />;
}

export default memo(CompDataLogo);
